import React, { useEffect, useState } from 'react'
import { supabase } from '../supabaseClient'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './ClienteDetalhesModal.css'

const ABAS = [
  { id: 'pessoais', icon: 'bi-person-badge', label: 'Dados Pessoais' },
  { id: 'local', icon: 'bi-geo-alt', label: 'Local da Instalação' },
  { id: 'financeiro', icon: 'bi-wallet2', label: 'Financeiro e Venda' },
  { id: 'kit', icon: 'bi-sun', label: 'Kit Solar' },
  { id: 'vistoria', icon: 'bi-clipboard-check', label: 'Vistoria' },
  { id: 'instalacao', icon: 'bi-tools', label: 'Instalação' },
  { id: 'homologacao', icon: 'bi-file-earmark-check', label: 'Homologação' }
]

const FORMAS_PAGAMENTO = {
  dinheiro: 'Dinheiro / À Vista',
  aprazo: 'A Prazo',
  pix: 'Pix / Transferência',
  cartao: 'Cartão de Crédito',
  financiamento: 'Financiamento Bancário',
  credito: 'Cartão de Crédito',
  boleto: 'Boleto',
  debito: 'Débito'
}

const INSTITUICAO_SLUG = {
  solagora: 'Sol Agora',
  bv: 'BV Financeira',
  santander: 'Santander',
  losango: 'Losango',
  outros: 'Outros'
}

const ETAPAS_HOMOLOGACAO = [
  { tipo: 'parecer', nome: 'Parecer de Acesso' },
  { tipo: 'aumento_carga', nome: 'Aumento de Carga' },
  { tipo: 'vistoria', nome: 'Vistoria de conexão' }
]

const CAMPOS_FOTO_VISTORIA = [
  ['caminho_img_padrao', 'Padrão'],
  ['caminho_img_ramal', 'Ramal'],
  ['caminho_img_inversor', 'Inversor'],
  ['caminho_img_fachada', 'Fachada'],
  ['caminho_img_mapa', 'Mapa'],
  ['caminho_img_telhado', 'Telhado'],
  ['caminho_img_quadro', 'Quadro'],
  ['caminho_img_estrutura', 'Estrutura'],
  ['caminho_img_croqui', 'Croqui']
]

function formatCpf(cpf) {
  const d = String(cpf || '').replace(/\D/g, '')
  if (d.length !== 11) return cpf || 'Não informado'
  return d.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
}

function formatCep(cep) {
  const d = String(cep || '').replace(/\D/g, '').slice(0, 8)
  if (!d) return 'Não informado'
  if (d.length <= 5) return d
  return `${d.slice(0, 5)}-${d.slice(5)}`
}

function formatMoeda(value) {
  if (value == null || value === '') return 'Não informado'
  const n = typeof value === 'number' ? value : Number(String(value).replace(/\./g, '').replace(',', '.'))
  if (Number.isNaN(n)) return 'Não informado'
  return n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
}

function formatData(value) {
  if (!value) return 'Não informado'
  const raw = String(value)
  const iso = raw.includes('T') ? raw : `${raw.slice(0, 10)}T00:00:00`
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return raw
  return d.toLocaleDateString('pt-BR')
}

function formatDataHora(value) {
  if (!value) return 'Não informado'
  const d = new Date(value)
  if (Number.isNaN(d.getTime())) return String(value)
  return d.toLocaleString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  })
}

function textoOuNao(valor) {
  if (valor === 0) return '0'
  if (valor == null || String(valor).trim() === '') return 'Não informado'
  return String(valor)
}

function parseListaJson(valor) {
  if (Array.isArray(valor)) return valor
  if (typeof valor === 'string') {
    try {
      const parsed = JSON.parse(valor)
      return Array.isArray(parsed) ? parsed : []
    } catch {
      return []
    }
  }
  return []
}

function linhasKitDeFonte(lista, legado = {}) {
  const fonte = parseListaJson(lista)
  if (fonte.length > 0) {
    return fonte.map((linha) => ({
      marca: linha.marca || '',
      modelo: linha.modelo || '',
      potencia: linha.potencia ?? '',
      quantidade: linha.quantidade ?? ''
    }))
  }
  if (legado.marca || legado.modelo || legado.potencia || legado.quantidade) {
    return [{
      marca: legado.marca || '',
      modelo: legado.modelo || '',
      potencia: legado.potencia ?? '',
      quantidade: legado.quantidade ?? ''
    }]
  }
  return []
}

function kitDoCliente(fonte = {}) {
  return {
    inversores: linhasKitDeFonte(fonte.inversores, {
      marca: fonte.marca_inversor,
      modelo: fonte.modelo_inversor,
      potencia: fonte.potencia_inversor,
      quantidade: fonte.quantidade_inversor
    }),
    modulos: linhasKitDeFonte(fonte.modulos, {
      marca: fonte.marca_modulo,
      modelo: fonte.modelo_modulo,
      potencia: fonte.potencia_modulo,
      quantidade: fonte.quantidade_modulo
    })
  }
}

function urlsDeCampo(valor) {
  if (!valor) return []
  if (Array.isArray(valor)) return valor.flatMap(urlsDeCampo)
  if (typeof valor === 'object') return Object.values(valor).flatMap(urlsDeCampo)
  if (typeof valor !== 'string') return []
  const texto = valor.trim()
  if (!texto) return []
  if (texto.startsWith('[') || texto.startsWith('{')) {
    try {
      return urlsDeCampo(JSON.parse(texto))
    } catch {
      return []
    }
  }
  if (/^https?:\/\//i.test(texto) || texto.includes('supabase')) return [texto]
  return []
}

function statusEtapaLabel(status) {
  const s = String(status || 'pendente').toLowerCase()
  if (s === 'aprovado') return 'Aprovado'
  if (s === 'reprovado') return 'Reprovado'
  if (s === 'atrasado') return 'Atrasado'
  return 'Pendente'
}

function InfoItem({ label, children, full }) {
  return (
    <div className={`cliente-detalhes-item${full ? ' is-full' : ''}`}>
      <span className="cliente-detalhes-label">{label}</span>
      <span className="cliente-detalhes-valor">{children}</span>
    </div>
  )
}

function InfoGrid({ children }) {
  return <div className="cliente-detalhes-grid">{children}</div>
}

function CardBloco({ titulo, children }) {
  return (
    <div className="cliente-detalhes-card">
      {titulo ? <h5>{titulo}</h5> : null}
      {children}
    </div>
  )
}

function Vazio({ texto }) {
  return <p className="cliente-detalhes-vazio">{texto}</p>
}

function FotosLista({ itens }) {
  if (!itens?.length) return null
  return (
    <div className="cliente-detalhes-fotos">
      {itens.map((foto) => (
        <a key={`${foto.label}-${foto.url}`} href={foto.url} target="_blank" rel="noreferrer" className="cliente-detalhes-foto">
          <img src={foto.url} alt={foto.label} />
          <span>{foto.label}</span>
        </a>
      ))}
    </div>
  )
}

export default function ClienteDetalhesModal({
  cliente,
  onClose,
  onEdit,
  onDelete,
  onDocumentos
}) {
  const [aba, setAba] = useState('pessoais')
  const [carregando, setCarregando] = useState(true)
  const [pagamentos, setPagamentos] = useState([])
  const [kit, setKit] = useState({ inversores: [], modulos: [] })
  const [vistorias, setVistorias] = useState([])
  const [osVistoria, setOsVistoria] = useState([])
  const [osInstalacao, setOsInstalacao] = useState([])
  const [baixasInstalacao, setBaixasInstalacao] = useState([])
  const [fluxos, setFluxos] = useState([])

  useEffect(() => {
    setAba('pessoais')
  }, [cliente?.id])

  useEffect(() => {
    let ativo = true
    const carregar = async () => {
      if (!cliente?.id) {
        setCarregando(false)
        return
      }
      setCarregando(true)
      try {
        const safe = async (promise, fallback) => {
          try {
            const { data, error } = await promise
            if (error) throw error
            return data
          } catch (err) {
            console.warn('Detalhes do cliente: consulta parcial falhou.', err?.message || err)
            return fallback
          }
        }

        const [
          pagamentosData,
          kitData,
          tiposData,
          osData,
          vistoriasData,
          fluxoData,
          clientesInstData,
          equipesData
        ] = await Promise.all([
          safe(
            supabase
              .from('clientes_pagamentos')
              .select('forma_pagamento, valor, instituicao_financiadora, financiamento_terceiro, documento_titular_url')
              .eq('cliente_id', cliente.id)
              .order('created_at', { ascending: true }),
            []
          ),
          safe(
            supabase
              .from('kit_solar_cliente')
              .select('marca_inversor, modelo_inversor, potencia_inversor, quantidade_inversor, marca_modulo, modelo_modulo, potencia_modulo, quantidade_modulo, inversores, modulos')
              .eq('id_cliente', cliente.id)
              .maybeSingle(),
            null
          ),
          safe(supabase.from('tipo_servico').select('id, nome'), []),
          safe(
            supabase
              .from('ordens_servicos')
              .select('id, id_tipo_servico, id_equipe, status, obs_operacional, obs_campo, data_execucao, data_criacao, created_at, presenca')
              .eq('id_cliente', cliente.id)
              .order('created_at', { ascending: false }),
            []
          ),
          safe(
            supabase
              .from('vistorias')
              .select('*')
              .eq('id_cliente', cliente.id)
              .order('created_at', { ascending: false }),
            []
          ),
          safe(
            supabase
              .from('fluxo_cliente')
              .select('id, uc, homologado, data_homologado, created_at, etapas:fluxo_cliente_etapas(*)')
              .eq('cliente_id', cliente.id)
              .order('created_at', { ascending: false }),
            []
          ),
          safe(
            supabase
              .from('clientes')
              .select('id, data_instalacao, quantidade_modulos, valor_obra, valor_material, nota_material, configuracao_inversor, tipo_servico_id, tipo_padrao_id, tipo_servico:tipo_servico(nome), tipo_padrao:tipo_padrao(nome)')
              .eq('id_cliente_cadastro', cliente.id),
            []
          ),
          safe(supabase.from('equipes').select('id, nome'), [])
        ])

        if (!ativo) return

        setPagamentos(pagamentosData || [])
        setKit(kitDoCliente(kitData || {}))

        const tipos = tiposData || []
        const nomeTipo = (id) => tipos.find((t) => String(t.id) === String(id))?.nome || 'Serviço'
        const idVistoria = tipos.find((t) => String(t.nome || '').trim().toLowerCase() === 'vistoria')?.id || null
        const equipesPorId = Object.fromEntries((equipesData || []).map((e) => [String(e.id), e.nome]))

        const ordens = (osData || []).map((os) => ({
          ...os,
          tipoNome: nomeTipo(os.id_tipo_servico),
          equipeNome: os.id_equipe ? (equipesPorId[String(os.id_equipe)] || 'Não informado') : 'Não informado'
        }))
        setOsVistoria(idVistoria
          ? ordens.filter((os) => String(os.id_tipo_servico) === String(idVistoria))
          : [])
        setOsInstalacao(idVistoria
          ? ordens.filter((os) => String(os.id_tipo_servico) !== String(idVistoria))
          : ordens)

        setVistorias(vistoriasData || [])
        setFluxos(fluxoData || [])
        setBaixasInstalacao((clientesInstData || []).map((row) => ({
          ...row,
          tipoNome: row.tipo_servico?.nome || nomeTipo(row.tipo_servico_id),
          padraoNome: row.tipo_padrao?.nome || 'Não informado'
        })))
      } catch (err) {
        console.error('Erro ao carregar detalhes do cliente:', err)
      } finally {
        if (ativo) setCarregando(false)
      }
    }
    carregar()
    return () => { ativo = false }
  }, [cliente?.id])

  const fotosVistoria = (vistoria) => CAMPOS_FOTO_VISTORIA.flatMap(([campo, label]) => (
    urlsDeCampo(vistoria?.[campo]).map((url) => ({ label, url }))
  ))

  const renderPessoais = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Informações Pessoais</h4>
        <p>Dados básicos de identificação do cliente.</p>
      </div>
      <InfoGrid>
        <InfoItem label="Nome completo" full>{textoOuNao(cliente.nome_completo)}</InfoItem>
        <InfoItem label="CPF">{formatCpf(cliente.cpf)}</InfoItem>
        <InfoItem label="RG">{textoOuNao(cliente.rg)}</InfoItem>
        <InfoItem label="Data de nascimento">{formatData(cliente.data_nascimento)}</InfoItem>
        <InfoItem label="Telefone / WhatsApp">{textoOuNao(cliente.telefone)}</InfoItem>
        <InfoItem label="E-mail">{textoOuNao(cliente.email)}</InfoItem>
        <InfoItem label="Fatura em nome de terceiro">{cliente.fatura_terceiro ? 'Sim' : 'Não'}</InfoItem>
        {cliente.fatura_terceiro && (
          <InfoItem label="Documento do titular da fatura">
            {cliente.documento_titular_fatura_url
              ? <a href={cliente.documento_titular_fatura_url} target="_blank" rel="noreferrer">Ver documento</a>
              : 'Não anexado'}
          </InfoItem>
        )}
        <InfoItem label="Cadastrado por">{textoOuNao(cliente.responsavel_nome)}</InfoItem>
        <InfoItem label="Data do cadastro">{formatData(cliente.data_cadastro || cliente.created_at)}</InfoItem>
        <InfoItem label="Status">{cliente.ativo === false ? 'Inativo' : 'Ativo'}</InfoItem>
      </InfoGrid>
    </>
  )

  const renderLocal = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Local da Instalação</h4>
        <p>Endereço onde o serviço será realizado.</p>
      </div>
      <InfoGrid>
        <InfoItem label="CEP">{formatCep(cliente.cep)}</InfoItem>
        <InfoItem label="Logradouro">{textoOuNao(cliente.logradouro)}</InfoItem>
        <InfoItem label="Número">{textoOuNao(cliente.numero)}</InfoItem>
        <InfoItem label="Complemento">{textoOuNao(cliente.complemento)}</InfoItem>
        <InfoItem label="Bairro">{textoOuNao(cliente.bairro)}</InfoItem>
        <InfoItem label="Cidade">{textoOuNao(cliente.cidade)}</InfoItem>
        <InfoItem label="Estado">{textoOuNao(cliente.estado)}</InfoItem>
        <InfoItem label="Google Maps" full>
          {cliente.link_localizacao
            ? <a href={cliente.link_localizacao} target="_blank" rel="noreferrer">{cliente.link_localizacao}</a>
            : 'Não informado'}
        </InfoItem>
      </InfoGrid>
      {cliente.foto_fachada && (
        <div className="cliente-detalhes-fachada">
          <span className="cliente-detalhes-label">Foto da fachada</span>
          <a href={cliente.foto_fachada} target="_blank" rel="noreferrer">
            <img src={cliente.foto_fachada} alt="Foto da fachada" />
          </a>
        </div>
      )}
    </>
  )

  const renderFinanceiro = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Dados Financeiros e Venda</h4>
        <p>Pagamentos e detalhes comerciais do projeto.</p>
      </div>
      <InfoGrid>
        <InfoItem label="Valor total do projeto">{formatMoeda(cliente.valor_total)}</InfoItem>
        <InfoItem label="Valor da majoração">{formatMoeda(cliente.majoracao)}</InfoItem>
        <InfoItem label="Data da compra">{formatData(cliente.data_compra)}</InfoItem>
        <InfoItem label="Cliente indicado">{cliente.indicacao ? 'Sim' : 'Não'}</InfoItem>
        {cliente.indicacao && (
          <>
            <InfoItem label="CPF do parceiro">{formatCpf(cliente.cpf_indicador)}</InfoItem>
            <InfoItem label="Nome do indicador">{textoOuNao(cliente.nome_indicador)}</InfoItem>
          </>
        )}
        <InfoItem label="Observações gerais" full>{textoOuNao(cliente.observacoes)}</InfoItem>
      </InfoGrid>

      <h5 className="cliente-detalhes-subtitulo">Composição de pagamento</h5>
      {pagamentos.length === 0 ? (
        <Vazio texto="Nenhum pagamento cadastrado." />
      ) : pagamentos.map((p, idx) => (
        <CardBloco key={idx} titulo={`Pagamento ${idx + 1}`}>
          <InfoGrid>
            <InfoItem label="Forma">{FORMAS_PAGAMENTO[p.forma_pagamento] || textoOuNao(p.forma_pagamento)}</InfoItem>
            <InfoItem label="Valor">{formatMoeda(p.valor)}</InfoItem>
            {p.forma_pagamento === 'financiamento' && (
              <>
                <InfoItem label="Instituição financiadora">{INSTITUICAO_SLUG[p.instituicao_financiadora] || textoOuNao(p.instituicao_financiadora)}</InfoItem>
                <InfoItem label="Financiamento em nome de terceiro">{p.financiamento_terceiro ? 'Sim' : 'Não'}</InfoItem>
                {p.financiamento_terceiro && (
                  <InfoItem label="Documento do titular" full>
                    {p.documento_titular_url
                      ? <a href={p.documento_titular_url} target="_blank" rel="noreferrer">Ver documento</a>
                      : 'Não anexado'}
                  </InfoItem>
                )}
              </>
            )}
          </InfoGrid>
        </CardBloco>
      ))}
    </>
  )

  const renderKitLinhas = (linhas, unidade, titulo, itemLabel) => (
    <>
      <h5 className="cliente-detalhes-subtitulo">{titulo}</h5>
      {linhas.length === 0 ? (
        <Vazio texto={`Nenhum ${itemLabel.toLowerCase()} cadastrado.`} />
      ) : linhas.map((linha, idx) => (
        <CardBloco key={`${titulo}-${idx}`} titulo={`${itemLabel} ${idx + 1}`}>
          <InfoGrid>
            <InfoItem label="Marca">{textoOuNao(linha.marca)}</InfoItem>
            <InfoItem label="Modelo">{textoOuNao(linha.modelo)}</InfoItem>
            <InfoItem label={`Potência (${unidade})`}>{textoOuNao(linha.potencia)}</InfoItem>
            <InfoItem label="Quantidade">{textoOuNao(linha.quantidade)}</InfoItem>
          </InfoGrid>
        </CardBloco>
      ))}
    </>
  )

  const renderKit = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Kit Solar</h4>
        <p>Modelos de inversor e módulo deste cliente.</p>
      </div>
      {renderKitLinhas(kit.inversores, 'kW', 'Inversores', 'Inversor')}
      {renderKitLinhas(kit.modulos, 'W', 'Módulos', 'Módulo')}
    </>
  )

  const renderVistoria = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Vistoria</h4>
        <p>Ordens e formulário de vistoria de campo.</p>
      </div>
      {!osVistoria.length && !vistorias.length && (
        <Vazio texto="Nenhuma vistoria registrada para este cliente." />
      )}
      {osVistoria.map((os) => (
        <CardBloco key={os.id} titulo="Ordem de vistoria">
          <InfoGrid>
            <InfoItem label="Status">{textoOuNao(os.status)}</InfoItem>
            <InfoItem label="Equipe">{textoOuNao(os.equipeNome)}</InfoItem>
            <InfoItem label="Data de criação">{formatData(os.data_criacao || os.created_at)}</InfoItem>
            <InfoItem label="Data de execução">{formatData(os.data_execucao)}</InfoItem>
            <InfoItem label="Observação operacional" full>{textoOuNao(os.obs_operacional)}</InfoItem>
            <InfoItem label="Observação de campo" full>{textoOuNao(os.obs_campo)}</InfoItem>
          </InfoGrid>
        </CardBloco>
      ))}
      {vistorias.map((v) => (
        <CardBloco key={v.id} titulo="Formulário de vistoria">
          <InfoGrid>
            <InfoItem label="Status">{textoOuNao(v.status)}</InfoItem>
            <InfoItem label="Data da vistoria">{formatData(v.data_vistoria)}</InfoItem>
            <InfoItem label="Ligação do padrão">{textoOuNao(v.ligacao_padrao)}</InfoItem>
            <InfoItem label="Local do inversor">{textoOuNao(v.local_inversor)}</InfoItem>
            <InfoItem label="Conexão do inversor">{textoOuNao(v.conexao_inversor)}</InfoItem>
            <InfoItem label="Poste da concessionária">{textoOuNao(v.posicao_poste_concessionaria)}</InfoItem>
            <InfoItem label="Local do aterramento">{textoOuNao(v.local_aterramento_sistema)}</InfoItem>
            <InfoItem label="Metragem C.A. inversor (m)">{textoOuNao(v.metragem_ca_inversor)}</InfoItem>
            <InfoItem label="Metragem C.C. (m)">{textoOuNao(v.metragem_cc)}</InfoItem>
            <InfoItem label="Metragem C.A. padrão — fases (m)">{textoOuNao(v.metragem_ca_padrao_fases)}</InfoItem>
            <InfoItem label="Qtd. conduletes inversor">{textoOuNao(v.qtd_conduletes_inversor)}</InfoItem>
            <InfoItem label="Qtd. eletroduto inversor">{textoOuNao(v.qtd_eletroduto_inversor)}</InfoItem>
            <InfoItem label="Qtd. eletroduto padrão">{textoOuNao(v.qtd_eletroduto_padrao)}</InfoItem>
            <InfoItem label="Qtd. módulos telhado">{textoOuNao(v.qtd_modulos_telhado)}</InfoItem>
            <InfoItem label="Percurso aterramento (m)">{textoOuNao(v.percurso_aterramento)}</InfoItem>
            <InfoItem label="Km rodado">{textoOuNao(v.km_rodado)}</InfoItem>
            <InfoItem label="Tipo de veículo">{textoOuNao(v.tipo_veiculo)}</InfoItem>
            <InfoItem label="Observações" full>{textoOuNao(v.observacoes)}</InfoItem>
          </InfoGrid>
          <FotosLista itens={fotosVistoria(v)} />
        </CardBloco>
      ))}
    </>
  )

  const renderInstalacao = () => (
    <>
      <div className="cliente-detalhes-pane-header">
        <h4>Instalação</h4>
        <p>Ordens de serviço e dados de baixa da instalação.</p>
      </div>
      {!osInstalacao.length && !baixasInstalacao.length && (
        <Vazio texto="Nenhuma instalação registrada para este cliente." />
      )}
      {osInstalacao.map((os) => (
        <CardBloco key={os.id} titulo={os.tipoNome || 'Ordem de serviço'}>
          <InfoGrid>
            <InfoItem label="Status">{textoOuNao(os.status)}</InfoItem>
            <InfoItem label="Equipe">{textoOuNao(os.equipeNome)}</InfoItem>
            <InfoItem label="Presença">{textoOuNao(os.presenca)}</InfoItem>
            <InfoItem label="Data de criação">{formatData(os.data_criacao || os.created_at)}</InfoItem>
            <InfoItem label="Data de execução">{formatData(os.data_execucao)}</InfoItem>
            <InfoItem label="Observação operacional" full>{textoOuNao(os.obs_operacional)}</InfoItem>
            <InfoItem label="Observação de campo" full>{textoOuNao(os.obs_campo)}</InfoItem>
          </InfoGrid>
        </CardBloco>
      ))}
      {baixasInstalacao.map((baixa) => (
        <CardBloco key={baixa.id} titulo={`Baixa — ${baixa.tipoNome || 'Instalação'}`}>
          <InfoGrid>
            <InfoItem label="Data da instalação">{formatData(baixa.data_instalacao)}</InfoItem>
            <InfoItem label="Tipo de padrão">{textoOuNao(baixa.padraoNome)}</InfoItem>
            <InfoItem label="Quantidade de módulos">{textoOuNao(baixa.quantidade_modulos)}</InfoItem>
            <InfoItem label="Configuração do inversor">{textoOuNao(baixa.configuracao_inversor)}</InfoItem>
            <InfoItem label="Valor da obra">{formatMoeda(baixa.valor_obra)}</InfoItem>
            <InfoItem label="Nota de material">{baixa.nota_material ? 'Sim' : 'Não'}</InfoItem>
            <InfoItem label="Valor do material">{formatMoeda(baixa.valor_material)}</InfoItem>
          </InfoGrid>
        </CardBloco>
      ))}
    </>
  )

  const renderHomologacao = () => {
    const homologadoCadastro = cliente.homologado === true
    return (
      <>
        <div className="cliente-detalhes-pane-header">
          <h4>Homologação</h4>
          <p>Fluxo de parecer, aumento de carga e vistoria de conexão.</p>
        </div>
        {!fluxos.length && !homologadoCadastro && !cliente.data_homologado && (
          <Vazio texto="Nenhum processo de homologação iniciado para este cliente." />
        )}
        {fluxos.map((fluxo) => (
          <React.Fragment key={fluxo.id}>
            <CardBloco titulo="Processo">
              <InfoGrid>
                <InfoItem label="UC">{textoOuNao(fluxo.uc)}</InfoItem>
                <InfoItem label="Cliente homologado">{(fluxo.homologado || homologadoCadastro) ? 'Sim' : 'Não'}</InfoItem>
                <InfoItem label="Data da homologação">{formatDataHora(fluxo.data_homologado || cliente.data_homologado)}</InfoItem>
              </InfoGrid>
            </CardBloco>
            {ETAPAS_HOMOLOGACAO.map((et) => {
              const etapa = (fluxo.etapas || []).find((e) => e.tipo_etapa === et.tipo)
              return (
                <CardBloco key={et.tipo} titulo={et.nome}>
                  <InfoGrid>
                    <InfoItem label="Status">{statusEtapaLabel(etapa?.status)}</InfoItem>
                    <InfoItem label="Protocolo">{textoOuNao(etapa?.protocolo)}</InfoItem>
                    <InfoItem label="Data">{formatData(etapa?.data_etapa)}</InfoItem>
                  </InfoGrid>
                </CardBloco>
              )
            })}
          </React.Fragment>
        ))}
        {!fluxos.length && (homologadoCadastro || cliente.data_homologado) && (
          <CardBloco titulo="Cadastro do cliente">
            <InfoGrid>
              <InfoItem label="Cliente homologado">{homologadoCadastro ? 'Sim' : 'Não'}</InfoItem>
              <InfoItem label="Data da homologação">{formatDataHora(cliente.data_homologado)}</InfoItem>
            </InfoGrid>
          </CardBloco>
        )}
      </>
    )
  }

  const conteudoAba = {
    pessoais: renderPessoais,
    local: renderLocal,
    financeiro: renderFinanceiro,
    kit: renderKit,
    vistoria: renderVistoria,
    instalacao: renderInstalacao,
    homologacao: renderHomologacao
  }

  return (
    <div className="modal-overlay cliente-detalhes-overlay" onClick={onClose}>
      <div className="modal-content cliente-detalhes-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <div>
            <h3>👤 Detalhes do Cliente</h3>
            <p className="cliente-detalhes-nome">{cliente.nome_completo}</p>
          </div>
          <button type="button" onClick={onClose} className="modal-close">×</button>
        </div>

        <nav className="cliente-detalhes-nav" aria-label="Abas dos detalhes do cliente">
          {ABAS.map((tab) => (
            <button
              key={tab.id}
              type="button"
              className={`cliente-detalhes-nav-btn${aba === tab.id ? ' is-active' : ''}`}
              onClick={() => setAba(tab.id)}
            >
              <i className={`bi ${tab.icon}`} aria-hidden="true" />
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="modal-body cliente-detalhes-body">
          {carregando ? <p className="cliente-detalhes-vazio">Carregando informações...</p> : conteudoAba[aba]?.()}
        </div>

        <div className="modal-footer cliente-detalhes-footer">
          <div className="cliente-detalhes-acoes">
            <button type="button" className="btn-action btn-edit" onClick={onEdit} title="Editar cliente">
              ✏️ Editar
            </button>
            <button type="button" className="btn-action btn-delete" onClick={onDelete} title="Excluir cliente">
              🗑️ Excluir
            </button>
            <button type="button" className="btn-action btn-docs" onClick={onDocumentos} title="Gerenciar documentos">
              📄 Documentos
            </button>
          </div>
          <button type="button" onClick={onClose} className="cliente-detalhes-btn-fechar">
            Fechar
          </button>
        </div>
      </div>
    </div>
  )
}
